import { Injectable } from '@angular/core';
// import { DailyMax, DailyMaxDayConfig } from '../data/campaignFinance';

@Injectable({
  providedIn: 'root'
})
export class CampaignService {

  constructor() { }

  // normalizeDailyMax(input: any): DailyMax {
  //   const resultDays: any = {};
  //   for (let i = 0; i < 7; i++) {
  //     resultDays[i] = this.defaultDay();
  //   }
  //   if(typeof input === 'string'){
  //     for (let i = 0; i < 7; i++) {
  //       resultDays[i] = {
  //         pause: false,
  //         maxleads: input,
  //         timestart: 0,
  //         timeend: 0
  //       };
  //     }
  //   }
  //   else if (Array.isArray(input)) {
  //     for (let i = 0; i < 7; i++) {
  //       resultDays[i] = {
  //         pause: false,
  //         maxleads: (input && input[i]) != null ? input[i] : 0,
  //         timestart: 0,
  //         timeend: 0
  //       };
  //     }
  //   } else if (
  //     input &&
  //     typeof input === 'object' &&
  //     input.days &&
  //     typeof input.days === 'object'
  //   ) {
  //     for (let i = 0; i < 7; i++) {
  //       const key = i.toString();
  //       const src = input.days[key];
  
  //       resultDays[key] = {
  //         pause: src && src.pause != null ? src.pause : false,
  //         maxleads: src && src.maxleads != null ? src.maxleads : 0,
  //         timestart: src && src.timestart != null ? src.timestart : 0,
  //         timeend: src && src.timeend != null ? src.timeend : 0,
  //       };
  //     }
  //   }
  
  //   return {
  //     type: 'weekly',
  //     days: resultDays,
  //   };
  // }

  // defaultDay(): DailyMaxDayConfig {
  //     return {
  //       pause: false,
  //       maxleads: 0,
  //       timestart: 0,
  //       timeend: 24,
  //     };
  // }
  

}
